import { Badge, type BadgeProps } from "@mantine/core"
import classes from "./KbdBadge.module.css"
import { useOs } from "@mantine/hooks"
import clsx from "clsx"

interface Props extends BadgeProps {
  text: {
    mac: string
    base: string
  }
}

export function KbdBadge({ children, text, classNames, ...props }: Props) {
  const os = useOs()

  return (
    <Badge
      variant="light"
      color="gray"
      radius="sm"
      {...props}
      classNames={{
        ...classNames,
        root: clsx(classes.root, "kbd-badge"),
        label: classes.label,
      }}
    >
      {os === "macos" ? text.mac : text.base}
    </Badge>
  )
}
